<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <product-category-form
          @submit="submit"
          :init-product-category="{}"
          :val-errors="valErrors"
          :product-categories="productCategories"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import ProductCategoryForm from './product-category-form'

export default {
  components: { ProductCategoryForm },
  data () {
    return {
      productCategories: [],
      valErrors: []
    }
  },
  methods: {
    async submit (productCat) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('product_categories', productCat).then(({ data }) => {
        this.$notify({
          message: 'Produktkategorie erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/product_categories')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/product_categories?onlyParents`).then(({ data }) => {
      this.productCategories = data
    })
  }
}
</script>

<style>
</style>
